/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserActivityInfo} from '../models/UserActivityInfo';

export interface GetUserActivity$Request {
    userId: number;
}

export interface GetUserActivity$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserActivityRequest = createAction<PayloadData<void, GetUserActivity$Request>>('GET_USER_ACTIVITY__GET_USER_ACTIVITY__REQUEST');
export const getUserActivitySuccess = createAction<PayloadData<UserActivityInfo, GetUserActivity$Request>>('GET_USER_ACTIVITY__GET_USER_ACTIVITY__SUCCESS');
export const getUserActivityFailure = createAction<PayloadData<Error, GetUserActivity$Request, true>>('GET_USER_ACTIVITY__GET_USER_ACTIVITY__FAILURE');

export const getUserActivityActions = [
    getUserActivityRequest,
    getUserActivitySuccess,
    getUserActivityFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserActivity = (meta: GetUserActivity$Request, config?: GetUserActivity$Config) => {
    return {
        CALL_API: {
            types: getUserActivityActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/profile/activity-info`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

